<script setup lang="ts">
import AppIcon from './AppIcon.vue';
</script>

<template>
  <div class="page-stack">
    <section class="panel">
      <div class="section-head">
        <span class="section-icon"><AppIcon name="people" /></span>
        <div>
          <h2>Share specific devices with people you trust.</h2>
          <p>
            ATUM Remote is for you and the people you invite. Each person sees only the devices
            shared with them, with separate desktop and terminal permissions.
          </p>
        </div>
      </div>
      <ol class="steps">
        <li>
          <strong>Invite</strong>
          <span>Send an invitation to a person's ATUM account.</span>
        </li>
        <li>
          <strong>Choose devices</strong>
          <span>Pick which devices they can see. Groups are labels, not access rules.</span>
        </li>
        <li>
          <strong>Set permissions</strong>
          <span>Grant desktop, terminal or both, per device. Revoke at any time.</span>
        </li>
      </ol>
      <div class="callout" data-tone="warn">
        <AppIcon name="info" />
        <div>
          <strong>Invitations are not available yet</strong>
          <p>
            This version supports your owner account and SSH connections. Per-person permissions and
            invitations need server support before anyone can be invited here.
          </p>
        </div>
      </div>
      <div class="button-row">
        <button type="button" class="primary" disabled>
          <AppIcon name="plus" />Invite someone
        </button>
      </div>
    </section>
  </div>
</template>
